export function resultTreeMapTransformer(p: Promise<any>, parentKey: string, fieldName: string) {
    return p.then((res: Array<any>) => {
        const groups = res.unique(parentKey)
        return groups.map(group => {
            return {
                [fieldName]: group[parentKey],
                items: res.filter(p => p[parentKey] == group[parentKey])
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/utils/tree.ts